/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusDropdownMiniDto } from '../../models/lexplus-dropdown-mini-dto';

export interface FunktionenControllerGetAllDropdownOptionsWithKeywordV1$Params {
  keyword: string;
}

export function funktionenControllerGetAllDropdownOptionsWithKeywordV1(http: HttpClient, rootUrl: string, params: FunktionenControllerGetAllDropdownOptionsWithKeywordV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusDropdownMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerGetAllDropdownOptionsWithKeywordV1.PATH, 'get');
  if (params) {
    rb.path('keyword', params.keyword, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusDropdownMiniDto>>;
    })
  );
}

funktionenControllerGetAllDropdownOptionsWithKeywordV1.PATH = '/v1/funktionen/dropdown-options/{keyword}';
